// extracted by mini-css-extract-plugin
module.exports = {"container":"Menu_container__JD1Pc","menuArea":"Menu_menuArea__xsC4D","menuItem":"Menu_menuItem__pN2e0"};